/** 公司审核字段元数据 — UI 与产品共用 FRF / ResultCode 约定 */

export {
  isProductApprovalResultRadioSelected as isCompanyApprovalResultRadioSelected,
  PRODUCT_APPROVAL_RESULT_CODE_SELECTED as COMPANY_APPROVAL_RESULT_CODE_SELECTED,
  PRODUCT_APPROVAL_RESULT_CODE_UNSELECTED as COMPANY_APPROVAL_RESULT_CODE_UNSELECTED,
  resolveProductApprovalResultCodeForSave as resolveCompanyApprovalResultCodeForSave,
  isProductApprovalRejectedRow as isCompanyApprovalRejectedRow,
  resolveProductRejectReasonText as resolveCompanyRejectReasonText,
  resolveProductApprovalContentKind as resolveCompanyApprovalContentKind,
  parseProductApprovalContentDisplay as parseCompanyApprovalContentDisplay,
} from '../NewproductInfoCenter/productApprovalFieldMeta';

/** TabSection → 公司 Tab i18n */
const COMPANY_APPROVAL_SECTION_I18N = {
  'Basic & Trade Info': 'lbl_EMPBE_CompanyInfo_Tab_First_Name',
  'Contract & Enquiry': 'lbl_EMPBE_CompanyInfo_Tab_Seconed_Name',
  'Customised eBooth': 'lbl_EMPBE_CompanyInfo_Tab_Thred_Name',
  Certification: 'lbl_EMPBE_CompanyInfo_Tab_Four_Name',
  'Our Client': 'lbl_EMPBE_CompanyInfo_Tab_Five_Name',
};

/** UsageType / DbColumnName → 字段 i18n（与各 Tab 表单标题一致） */
const COMPANY_APPROVAL_FIELD_I18N = {
  companyNameE: 'lbl_EMPBE_CompanyInfo_Basic_CompanyName_En',
  companyShortNameE: 'lbl_EMPBE_CompanyInfo_Basic_CompanyShortName_En',
  companyNameS: 'lbl_EMPBE_CompanyInfo_Basic_CompanyName_Cn',
  companyShortNameS: 'lbl_EMPBE_CompanyInfo_Basic_CompanyShortName_Cn',
  companyWebsite: 'lbl_EMPBE_CompanyInfo_Basic_Website',
  businessNatureOther: 'lbl_EMPBE_CompanyInfo_Basic_Other',
  companyAddressE: 'lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_En',
  companyAddressS: 'lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_Cn',
  CompanyHeadquarter: 'lbl_EMPBE_CompanyInfo_Contact_HeadquarterPhoto',
  companyTel: 'lbl_EMPBE_CompanyInfo_Contact_CompanyTelephone',
  briefIntroE: 'lbl_EMPBE_CompanyInfo_eBooth_BriefIntro_En',
  briefIntroS: 'lbl_EMPBE_CompanyInfo_eBooth_BriefIntro_Cn',
  CompanyLogo: 'lbl_EMPBE_CompanyInfo_eBooth_CompanyLogo',
  BannerSlider: 'lbl_EMPBE_CompanyInfo_eBooth_SpotlightSlidingBanners',
  headlineE: 'lbl_EMPBE_CompanyInfo_eBooth_Headline_En',
  bodyTextE: 'lbl_EMPBE_CompanyInfo_eBooth_Description_En',
  headlineS: 'lbl_EMPBE_CompanyInfo_eBooth_Headline_Cn',
  bodyTextS: 'lbl_EMPBE_CompanyInfo_eBooth_Description_Cn',
  CompanyVideo: 'lbl_EMPBE_CompanyInfo_eBooth_CompanyVideoSubtitle',
  CompanyShortVideo: 'lbl_EMPBE_CompanyInfo_eBooth_CompanyShortVideoSubtitle',
  PhotoGallery: 'lbl_EMPBE_CompanyInfo_eBooth_PhotoGallery',
  CertificationType: 'lbl_EMPBE_CompanyInfo_Certification_certificationType_PlaceOther',
  CertificationName: 'lbl_EMPBE_CompanyInfo_Certification_certificationName_PlaceOther',
  MgmtCertImage: 'lbl_EMPBE_CompanyInfo_Certification_CertImage',
  ClientName: 'lbl_EMPBE_CompanyInfo_ClientList_CompanyClientName',
};

function translateOrFallback(t, key, fallback, params) {
  if (!key || typeof t !== 'function') return fallback || key || '';
  const translated = params ? t(key, params) : t(key);
  if (translated && translated !== key) return translated;
  return fallback || key;
}

export function resolveCompanyApprovalSectionLabel(t, tabSection, fallback = '') {
  const section = String(tabSection || '').trim();
  const key = COMPANY_APPROVAL_SECTION_I18N[section];
  if (key) return translateOrFallback(t, key, section || fallback);
  return section || fallback || '';
}

export function resolveCompanyApprovalFieldLabel(t, usageType, fieldName = '') {
  const usage = String(usageType || '').trim();
  const key = COMPANY_APPROVAL_FIELD_I18N[usage];
  const fallback = String(fieldName || '').trim() || usage || '-';
  if (key) return translateOrFallback(t, key, fallback);
  return fallback;
}

/** 各 Tab ProgressPage → 驳回 UsageType 列表（与 Enqueue / 映射一致） */
export const COMPANY_REJECT_USAGE_TYPES_BY_TAB = {
  BasicInfo: [
    'companyNameE', 'companyShortNameE', 'companyNameS', 'companyShortNameS',
    'companyWebsite', 'businessNatureOther',
  ],
  ContactAndEnquiry: [
    'companyAddressE', 'companyAddressS', 'CompanyHeadquarter', 'companyTel',
  ],
  CustomisedEBooth: [
    'briefIntroE', 'briefIntroS', 'CompanyLogo', 'BannerSlider',
    'headlineE', 'bodyTextE', 'headlineS', 'bodyTextS',
    'CompanyVideo', 'CompanyShortVideo', 'PhotoGallery',
  ],
  Certification: ['CertificationType', 'CertificationName', 'MgmtCertImage'],
  OurClient: ['ClientName'],
};
